<template>
  <div style="display:flex;align-items:center;">
    <div class="searchinput">
      <input placeholder="请输入项目名或项目编号来搜索项目" class="input" v-model="inputValue" @keyup.enter="keyupEnter" style="width:260px;height:30px;background-color: transparent"></input>
      <i class="el-icon-search" style="color:#ffffff;margin-left:2px" @click="searchIconAction"></i>
<!--      <i class="el-icon-circle-close" style="color:#ffffff;margin-right:2px" @click="closeSearchInput"></i>-->
    </div>
<!--    <i class="el-icon-search" style="color:#ffffff" @click="searchClick" v-show="searchbuttonShow"></i>-->
  </div>
</template>

<script>
export default {
  name: "SearchButton",
  data() {
    return {
      inputValue: "",
      searchbuttonShow: true,
      serachInputShow: false
    };
  },
  mounted() {
    this.getLocation();
  },
  methods: {
    // 从地址栏获取输入内容query
    getLocation() {
      let paramsLocation = window.location.hash.split("/")[1].split("?");
      if (paramsLocation[0] == "searchProject") {
        if (paramsLocation[1].split('&')[0].split('=')[0] == "query") {
          this.inputValue = this.decodeQuery(paramsLocation[1].split('&')[0].split('=')[1]);
        }
      }
    },
    // 解码参数
    decodeQuery(query) {
      let newquery = decodeURI(query);
      let flag = newquery.indexOf("%") >= 0;
      while (flag) {
        newquery = decodeURI(newquery);
        flag = newquery.indexOf("%") >= 0;
      }
      return newquery;
    },
    keyupEnter() {
      this.searchIconAction();
    },
    searchIconAction() {
      this.$emit("searchAction", this.inputValue);
      // this.inputValue = "";
    },
    closeSearchInput() {
      this.inputValue = "";
      this.searchbuttonShow = true;
      this.serachInputShow = false;
    },

    searchClick() {
      this.inputValue = "";
      this.searchbuttonShow = false;
      this.serachInputShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  padding-left: 5px;
  padding-right: 5px;
  width: 85px;
  font-size: 12px;
  background-color: #464646;
  border-width: 0px;
  color: #ffffff;
}
.input:focus {
  outline: none
}
.searchinput {
  align-items: center;
  display: flex;
  overflow: hidden;
  height: 30px;
  width: 300px;
  /*border-radius: 10px;*/
  border-color: #ffffff; // FFE58F
  border-width: 1px;
  border-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/js/components/searchButton.vue